import * as React from 'react';
import { PageProgress, updatePageProgress } from '../../../../../api/TourSignup';
import FormValidationDisplay from '../../../../common/form/ValidationDisplay';
import { HelpEmailLink, HelpPhoneLink } from '../../../../common/HelpLinks';
import { TourSignupProps } from '../TourRouter';

interface Props {
    errorMessage: string;
    tourProps: TourSignupProps;
}

const SignupFailedSubpage = (props: Props) => {
    if (props.tourProps.match.params.guestCardGuid !== undefined) {
        updatePageProgress(
            props.tourProps.match.params.guestCardGuid,
            PageProgress.TourScheduleFailure
        );
    }

    return (
        <div>
            <h3 className="prospect-signup-header">Tour Scheduling Failed</h3>
            <p>We apologize that we were unable to schedule a tour for you.</p>
            <p>We would still love to show you what our property has to offer!</p>
            <p>
                Please reach out to us at{' '}
                <b>
                    <HelpEmailLink />
                </b>{' '}
                or call us at{' '}
                <b>
                    <HelpPhoneLink />
                </b>{' '}
                to schedule a time to tour the property.
            </p>
            <p>Thanks for using Tour24!</p>
            <FormValidationDisplay errorMessage={props.errorMessage} />
        </div>
    );
};

export default SignupFailedSubpage;



// WEBPACK FOOTER //
// ./src/components/pages/prospect/signup/confirmation/SignupFailedSubpage.tsx